const COLORS = {
    gray: '#BAC4CE',
    white: '#FFF',
    primaryBtn: '#1168cd',
    border: '#C4C4C4',
};

export { COLORS };
